var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.3335 3.33337V12.6667L11.6668 8.00004L4.3335 3.33337Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }